var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "d-flex flex-column justify-center align-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700" },
          model: {
            value: _vm.npsDialog,
            callback: function($$v) {
              _vm.npsDialog = $$v
            },
            expression: "npsDialog"
          }
        },
        [
          _c("NPS", {
            attrs: { pce_id: _vm.exam.codigoCompra },
            on: { close: _vm.close }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "text--secondary d-flex justify-start align-center mb-3",
          staticStyle: { width: "100%" }
        },
        [
          _c(
            "v-btn",
            { staticClass: "ml-4", attrs: { icon: "", href: "/exams" } },
            [
              _c("v-icon", { attrs: { color: "#ccc" } }, [
                _vm._v("mdi-chevron-left")
              ]),
              _c(
                "span",
                { staticStyle: { "font-size": "0.7rem", color: "#999" } },
                [_vm._v("inicio")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSuccess,
              expression: "showSuccess"
            }
          ],
          staticClass: "alert",
          attrs: {
            transition: "scroll-x-reverse-transition",
            type: "success",
            border: "left",
            elevation: "3"
          }
        },
        [_vm._v(" " + _vm._s(_vm.message) + " ")]
      ),
      _c(
        "v-card",
        {
          staticClass: "pa-3 transition-swing",
          attrs: { "max-width": "800", "min-height": "400" }
        },
        [
          _c(
            "v-window",
            {
              model: {
                value: _vm.step,
                callback: function($$v) {
                  _vm.step = $$v
                },
                expression: "step"
              }
            },
            [
              _c("v-container", { staticClass: "d-flex" }, [
                _c("div", { staticClass: "my-2 mx-5" }, [
                  _c("h2", { staticClass: "section-title" }, [
                    _vm._v(_vm._s(_vm.exam.codigoCompra))
                  ]),
                  _c("strong", { staticClass: "subtitle" }, [
                    _vm._v(_vm._s(_vm._f("formatTitle")(_vm.exam.codigoStatus)))
                  ]),
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(_vm._s(_vm.switchDate(_vm.exam.codigoStatus)))
                  ]),
                  _vm.step !== 8
                    ? _c("p", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.exam.avisoB2BB2C))
                      ])
                    : _vm._e(),
                  _vm.step === 7
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex justify-center align-center",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "butt",
                              attrs: {
                                color: "primary",
                                small: "",
                                height: "25",
                                width: "160",
                                href:
                                  "https://api.whatsapp.com/send?phone=5511945022666",
                                target: "_blank"
                              }
                            },
                            [_vm._v("Entre em contato ")]
                          )
                        ],
                        1
                      )
                    : _vm.step === 8
                    ? _c("p", { staticClass: "text" }, [
                        _vm._v(
                          " Seu Exame esta em Analise em nosso Laboratório, aguarde o resultado "
                        )
                      ])
                    : _vm._e(),
                  _vm.step == 0
                    ? _c("p", { staticClass: "text" }, [
                        _vm._v("Coleta em análise")
                      ])
                    : _vm._e(),
                  _vm.step === 1
                    ? _c("strong", { staticClass: "text" }, [
                        _vm._v(
                          "Valor do Exame: R$" +
                            _vm._s(_vm.exam.examValue) +
                            " "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _c(
                "v-window-item",
                { attrs: { value: 1 } },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "ml-5 mt-2",
                      staticStyle: { color: "#555" }
                    },
                    [_vm._v("FORMA DE PAGAMENTO")]
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "px-6 d-flex justify-center align-center" },
                    [
                      _vm.exam.paymentForm == "E" ||
                      _vm.exam.paymentForm == "C" ||
                      _vm.exam.paymentForm == "L"
                        ? _c("v-img", {
                            attrs: {
                              src: require("../../../../assets/Boleto.png"),
                              alt: "Forma de Pagamento",
                              "max-width": "80"
                            }
                          })
                        : _vm._e(),
                      _c("strong", { staticClass: "subtitle ml-3" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatMode")(_vm.exam.paymentForm))
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.exam.paymentForm == "E" ||
                  _vm.exam.paymentForm == "C" ||
                  _vm.exam.paymentForm == "L"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "copy-button mx-auto",
                          attrs: { text: "" },
                          on: { click: _vm.copyBoleto }
                        },
                        [_vm._v(" COPIAR CÓDIGO DE BARRAS ")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                        margin: "30px 0"
                      }
                    },
                    [
                      _vm.exam.paymentForm == "E" ||
                      _vm.exam.paymentForm == "C" ||
                      _vm.exam.paymentForm == "L"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "butt mx-auto",
                              attrs: {
                                color: "primary",
                                small: "",
                                width: "140",
                                target: "_blank",
                                href: _vm.boleto.linK_BOLETO
                              }
                            },
                            [_vm._v("Acesse seu boleto ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.exam.paymentForm == "E" ||
                  _vm.exam.paymentForm == "C" ||
                  _vm.exam.paymentForm == "L"
                    ? _c("div", { staticClass: "pa-5" }, [
                        _c("p", { staticClass: "text" }, [
                          _vm._v(
                            " Boletos Bancários levam até 24 horas úteis para compensar. "
                          )
                        ]),
                        _c("p", { staticClass: "text" }, [
                          _vm._v(
                            " Sua nota fiscal estará disponivel até 24 horas úteis após o resultado ser liberado. "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 2 } },
                [
                  _vm.loading
                    ? _c(
                        "v-row",
                        { staticClass: "mx-2 my-4" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "my-5 d-flex justify-center align-center"
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.loading
                    ? _c("div", { staticClass: "pa-3" }, [
                        _c("div", { staticClass: "ml-2" }, [
                          _c("p", { staticClass: "orange-title" }, [
                            _vm._v(_vm._s(_vm.address.nomE_FANTASIA))
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "d-flex pa-3" },
                          [
                            _c("v-divider", {
                              staticClass: "mx-3 mb-12",
                              attrs: { vertical: "" }
                            }),
                            _c("div", [
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.address.tipO_LOGRADOURO) +
                                    " " +
                                    _vm._s(_vm.address.logradouro) +
                                    " " +
                                    _vm._s(_vm.address.enD_NUMERO) +
                                    " - " +
                                    _vm._s(_vm.address.enD_COMPLEMENTO) +
                                    " "
                                )
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s(_vm.address.bairro) +
                                    ", " +
                                    _vm._s(_vm.address.estado)
                                )
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _vm._v("Cep: " + _vm._s(_vm.address.cep))
                              ]),
                              _vm.address.telefone
                                ? _c("p", { staticClass: "text" }, [
                                    _vm._v(
                                      " Telefone: " +
                                        _vm._s(
                                          _vm.address.telefone != null
                                            ? _vm.address.telefone
                                            : "Sem registro"
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Caso tenha feito uso de medicamentos que possam ter afetado o resultado seu exame toxicológico, envia a prescrição médica. "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 3 } },
                [
                  _c("v-divider", { staticClass: "mx-3" }),
                  _c("div", { staticClass: "pa-8 text" }, [
                    _vm._v(
                      " Caso faça uso de medicamentos que possam afetar o resultado do seu exame toxicológico, preencha os dados abaixo para o envio da prescrição médica "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 4 } },
                [
                  _c("v-divider", { staticClass: "mx-3" }),
                  _c("div", { staticClass: "pa-8 text" }, [
                    _vm._v(
                      " Caso faça uso de medicamentos que possam afetar o resultado do seu exame toxicológico, preencha os dados abaixo para o envio da prescrição médica "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 0 } },
                [
                  _c("v-divider", { staticClass: "mx-3" }),
                  _c("div", { staticClass: "pa-8 text" }, [
                    _vm._v(
                      " Caso faça uso de medicamentos que possam afetar o resultado do seu exame toxicológico, preencha os dados abaixo para o envio da prescrição médica "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 5 } },
                [
                  _c("div", { staticClass: "mx-6 py-3" }, [
                    _vm._v(
                      " Seu resultado será inserido no RENACH e sua nota fiscal estará disponivel em até 24h úteis. "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "#555",
                            small: "",
                            loading: _vm.resultLoading
                          },
                          on: { click: _vm.getReportB2C }
                        },
                        [_vm._v("Ver resultado ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _vm.exam.hasContraProva
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "butt",
                              attrs: {
                                color: "#555",
                                small: "",
                                loading: _vm.resultLoading
                              },
                              on: { click: _vm.getReportContraProva }
                            },
                            [_vm._v("Ver resultado Contraprova ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-2" },
                    [
                      _vm.exam.origem == "B2B" ||
                      _vm.exam.pce_motivo_exame == "E" ||
                      _vm.exam.haveMedicalReport
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "butt",
                              attrs: {
                                color: "#555",
                                small: "",
                                loading: _vm.resultRMLoading
                              },
                              on: { click: _vm.getReportB2B }
                            },
                            [_vm._v("Relatório Médico ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "ma-3" }),
                  _vm.receipt && _vm.receipt.linkNfe
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-center mb-4 butt"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text text-center",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "0.9rem"
                              }
                            },
                            [_vm._v("Sua nota fiscal está disponivel.")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "butt mx-auto",
                              attrs: {
                                color: "primary",
                                small: "",
                                width: "140",
                                loading: _vm.receiptLoading,
                                target: "_blank",
                                href: _vm.receipt.linkNfe
                              }
                            },
                            [_vm._v("Ver nota fiscal ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Caso seu exame seja positivo e deseje contestar o resultado é possivel solicitar contraprova. "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4 butt" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            loading: _vm.proofLoading,
                            target: "_blank",
                            href: _vm.downloadPDF
                          },
                          on: { click: _vm.requestAgainsProof }
                        },
                        [_vm._v("Solicitar Contraprova ")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Caso tenha feito uso de medicamentos que possam ter afetado o resultado seu exame toxicológico, envia a prescrição médica. "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 6 } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-2" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "#555",
                            small: "",
                            loading: _vm.resultLoading
                          },
                          on: { click: _vm.getReportB2C }
                        },
                        [_vm._v("Ver resultado ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _vm.exam.hasContraProva
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "butt",
                              attrs: {
                                color: "#555",
                                small: "",
                                loading: _vm.resultLoading
                              },
                              on: { click: _vm.getReportContraProva }
                            },
                            [_vm._v("Ver resultado Contraprova ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-2" },
                    [
                      _vm.exam.origem == "B2B" ||
                      _vm.exam.pce_motivo_exame == "E" ||
                      _vm.exam.haveMedicalReport
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "butt",
                              attrs: {
                                color: "#555",
                                small: "",
                                loading: _vm.resultRMLoading
                              },
                              on: { click: _vm.getReportB2B }
                            },
                            [_vm._v("Relatório Médico ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Seu exame toxicológico tem validade até " +
                        _vm._s(_vm.formatDate(_vm.exam.dataColeta)) +
                        ". "
                    )
                  ]),
                  _c("v-divider", { staticClass: "mx-5" }),
                  _vm.receipt && _vm.receipt.linkNfe
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-center mb-4 butt"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text text-center",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "0.9rem"
                              }
                            },
                            [_vm._v("Sua nota fiscal está disponivel.")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "butt mx-auto",
                              attrs: {
                                color: "primary",
                                small: "",
                                width: "140",
                                loading: _vm.receiptLoading,
                                target: "_blank",
                                href: _vm.receipt.linkNfe
                              }
                            },
                            [_vm._v("Ver nota fiscal ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Caso seu exame seja positivo e deseje contestar o resultado é possivel solicitar contraprova. "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4 butt" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            loading: _vm.proofLoading,
                            target: "_blank",
                            href: _vm.downloadPDF
                          },
                          on: { click: _vm.requestAgainsProof }
                        },
                        [_vm._v("Solicitar Contraprova ")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "px-8 text d-flex" }, [
                    _vm._v(
                      " Caso tenha feito uso de medicamentos que possam ter afetado o resultado seu exame toxicológico, envia a prescrição médica. "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 7 } },
                [
                  _c("v-divider", { staticClass: "mx-3" }),
                  _c("div", { staticClass: "pa-8 text" }, [
                    _vm._v(
                      " Caso faça uso de medicamentos que possam afetar o resultado do seu exame toxicológico, preencha os dados abaixo para o envio da prescrição médica "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-window-item",
                { attrs: { value: 8 } },
                [
                  _c("v-divider", { staticClass: "mx-3" }),
                  _c("div", { staticClass: "pa-8 text" }, [
                    _vm._v(
                      " Caso faça uso de medicamentos que possam afetar o resultado do seu exame toxicológico, preencha os dados abaixo para o envio da prescrição médica "
                    )
                  ]),
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _vm.showForm
                        ? _c(
                            "v-row",
                            {
                              staticClass: "transition-swing flex-column mt-2",
                              attrs: { justify: "center", align: "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "CRM do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorCrm,
                                      callback: function($$v) {
                                        _vm.doctorCrm = $$v
                                      },
                                      expression: "doctorCrm"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##)####-####",
                                          "(##)#####-####"
                                        ],
                                        expression:
                                          "['(##)####-####', '(##)#####-####']"
                                      }
                                    ],
                                    staticClass: "doctor-field",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      label: "Telefone do Médico"
                                    },
                                    model: {
                                      value: _vm.doctorPhoneNumber,
                                      callback: function($$v) {
                                        _vm.doctorPhoneNumber = $$v
                                      },
                                      expression: "doctorPhoneNumber"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center pa-0" },
                                [
                                  _c("v-file-input", {
                                    staticClass: "doctor-field mb-8",
                                    attrs: {
                                      outlined: "",
                                      rules: [
                                        function(v) {
                                          return !!v || "Campo Obrigatório"
                                        }
                                      ],
                                      accept: ".pdf",
                                      label: "Prescrição",
                                      "prepend-inner-icon": "mdi-paperclip",
                                      "prepend-icon": "",
                                      "persistent-hint": "",
                                      hint:
                                        "Insira aqui o arquivo da sua prescrição (PDF)"
                                    },
                                    on: { change: _vm.setFile },
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center mb-4" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "butt",
                          attrs: {
                            color: "primary",
                            small: "",
                            height: "25",
                            width: "160",
                            loading: _vm.loading
                          },
                          on: { click: _vm.sendPrescription }
                        },
                        [_vm._v("Enviar prescrição ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }